import ScrollReveal from '@/components/base/ScrollReveal';

export default function PrivacyPage() {
  return (
    <main className="min-h-screen bg-background-50 pt-24 pb-16">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <ScrollReveal>
          <h1 className="text-3xl md:text-4xl font-heading font-bold text-primary-500 mb-2">
            Privacy Policy
          </h1>
          <p className="text-sm text-foreground-500 mb-8">
            Last updated: July 5, 2026
          </p>
        </ScrollReveal>

        <div className="prose prose-sm max-w-none text-foreground-700 space-y-6">
          <section>
            <h2 className="text-xl font-heading font-semibold text-primary-500 mb-3">
              1. Information We Collect
            </h2>
            <p>
              When you visit Joviaa or place an order, we may collect personal information including your name, email address, phone number, shipping address, PIN code, and payment method preference. For orders, we also collect billing address and GST details where applicable. We also collect non-personal data such as browser type, device information, IP address, and browsing behaviour through cookies and analytics tools.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-heading font-semibold text-primary-500 mb-3">
              2. How We Use Your Information
            </h2>
            <p>
              We use your information to process and fulfil orders, manage shipping and delivery within India, communicate about your orders and account, provide customer support via WhatsApp or email, improve our website and product offerings, send promotional communications (with your consent), comply with Indian tax and legal obligations including GST, and prevent fraud. We do not sell or rent your personal information to third parties.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-heading font-semibold text-primary-500 mb-3">
              3. Payment Processing
            </h2>
            <p>
              Payments are processed through secure, RBI-compliant third-party payment gateways. Joviaa does not store your complete credit card, debit card, or UPI PIN details on our servers. Your payment information is handled in accordance with the payment processor&apos;s privacy policy and PCI-DSS standards. All transactions are processed in Indian Rupees (INR).
            </p>
          </section>

          <section>
            <h2 className="text-xl font-heading font-semibold text-primary-500 mb-3">
              4. Cookies &amp; Tracking Technologies
            </h2>
            <p>
              We use cookies and similar technologies to enhance your browsing experience, analyse site traffic, remember your preferences (such as cart contents and style selections), and personalise content. You can manage cookie preferences through your browser settings. Disabling certain cookies may affect website functionality. For more details, please see our Cookie Policy.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-heading font-semibold text-primary-500 mb-3">
              5. Data Sharing
            </h2>
            <p>
              We may share your information with trusted third-party service providers who assist us in operating our website, processing payments, delivering orders via courier partners, and analysing data. These partners are contractually obligated to protect your information and use it only for the services they provide. We may also disclose information when required by law or to protect our rights.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-heading font-semibold text-primary-500 mb-3">
              6. Data Security
            </h2>
            <p>
              We implement industry-standard security measures including SSL encryption, secure server infrastructure, and access controls to protect your personal information. However, no method of transmission over the internet is 100% secure, and we cannot guarantee absolute security. You are responsible for keeping your account password confidential.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-heading font-semibold text-primary-500 mb-3">
              7. Your Rights
            </h2>
            <p>
              Under applicable Indian data protection principles, you have the right to access, correct, or delete your personal information held by us. You may also opt out of marketing communications at any time by clicking the unsubscribe link in our emails or contacting us directly. To exercise these rights, please email us at hello@joviaa.in.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-heading font-semibold text-primary-500 mb-3">
              8. Third-Party Links
            </h2>
            <p>
              Our website may contain links to third-party websites or services such as Instagram, YouTube, or payment gateways. We are not responsible for the privacy practices or content of those sites. We encourage you to review their privacy policies before providing any personal information.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-heading font-semibold text-primary-500 mb-3">
              9. Data Retention
            </h2>
            <p>
              We retain your personal information for as long as necessary to fulfil the purposes for which it was collected, including for tax, accounting, and legal compliance requirements under Indian law. Transaction records are retained for a minimum of 7 years as required by GST regulations.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-heading font-semibold text-primary-500 mb-3">
              10. Changes to This Policy
            </h2>
            <p>
              We may update this Privacy Policy periodically to reflect changes in our practices or applicable laws. Changes will be posted on this page with the updated date. Continued use of our website after changes constitutes acceptance of the revised policy.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-heading font-semibold text-primary-500 mb-3">
              11. Contact Us
            </h2>
            <p>
              If you have questions about this Privacy Policy, contact us at{' '}
              <a href="mailto:hello@joviaa.in" className="text-accent-500 underline">
                hello@joviaa.in
              </a>{' '}
              or WhatsApp +91 96865 43847.
            </p>
          </section>
        </div>
      </div>
    </main>
  );
}